var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{attrs:{"id":"chart-container","width":"500px"}}),_c('div',[_vm._v("最大队列："+_vm._s(_vm.maxQueueCount))])])}
var staticRenderFns = []

export { render, staticRenderFns }